// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#resourcepage-dropzone[data-v-335e75ef]{min-height:126px}#resourcepage-add-files[data-v-335e75ef]{padding-top:45px}.dz-uploaded-file[data-v-335e75ef]{cursor:default}", ""]);
// Exports
module.exports = exports;
